export default __webpack_public_path__ + "static/media/12.48455dd4.png";